<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between">
			<h2 class="mb-4">User</h2>
			<v-spacer></v-spacer>
			<v-btn
				v-if="emailList.length > 0"
				:class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : ''"
				color="primary"
				:block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600"
				@click="dialogEmailConfirmation = true"
				>Send to Selected User</v-btn
			>
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : 'ml-2'" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="dialogActive = true"
				>Activate All Users</v-btn
			>
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : 'ml-2'" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="dialogInactive = true"
				>Deactivate All Users</v-btn
			>
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : 'mx-2'" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="openDialog()">Import</v-btn>
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : ''" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="download('/system/user/download/data')"
				>Export</v-btn
			>
		</div>

		<div style="margin-top: 10px; margin-bottom: 10px; text-align: right">
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : 'ml-2'" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="dialogSendEmailNonExhibitor = true"
				>Send Email to Non-Exhibitor</v-btn
			>
			<v-btn :class="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600 ? 'mb-2' : 'ml-2'" color="primary" :block="$vuetify.breakpoint.smAndDown && $vuetify.breakpoint.width < 600" @click="dialogSendEmailExhibitor = true"
				>Send Email and Activate Exhibitor</v-btn
			>
		</div>

		<div>
			<v-card>
				<v-data-table v-model="emailList" :headers="headers" :items="experienceUserList.data" :footer-props="{ itemsPerPageOptions: [-1] }" :hide-default-footer="true" show-select>
					<template v-slot:item.image="{ item }">
						<v-avatar>
							<v-img :src="profilePicture1(item.image)" />
						</v-avatar>
					</template>
					<template v-slot:item.active="{ item }">{{ item.active ? "Active" : "Inactive" }}</template>
					<template v-slot:item.passwordSet="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on" :color="item.passwordSet ? 'success' : ''">
									{{ item.passwordSet ? "mdi-check" : "mdi-close" }}
								</v-icon>
							</template>
							<span>{{ item.passwordSet ? formatDateTime(item.passwordSet) : "Not yet" }}</span>
						</v-tooltip>
					</template>
					<template v-slot:item.emailed="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on" :color="item.emailed ? 'success' : ''" @click="emailList.push(item), (dialogEmailConfirmation = true)">mdi-email-arrow-right</v-icon>
							</template>
							<span>{{ item.dataMap.sendTime ? item.dataMap.sendTime : "Not yet sent" }}</span>
						</v-tooltip>
					</template>
					<template v-slot:top>
						<v-row class="mx-0 flex-row-reverse">
							<v-col cols="12" sm="2">
								<v-dialog v-model="dialogEditedItem" persistent max-width="700px">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary" dark block v-bind="attrs" v-on="on" @click="addItem()">Add</v-btn>
									</template>
									<v-card>
										<v-card-title>
											<span class="headline">
												{{ isNewUser ? "Add" : "Edit" }}
												User
											</span>
											<v-spacer></v-spacer>
											<v-btn icon @click="close">
												<v-icon>mdi-close</v-icon>
											</v-btn>
										</v-card-title>

										<v-form ref="formEditedItem" v-model="validEditedItem" @submit.prevent="save">
											<v-card-text>
												<v-container>
													<v-row v-if="!isNewUser" class="d-flex flex-column justify-center align-center">
														<v-badge :value="hover" icon="mdi-camera" avatar bottom bordered overlap offset-x="40" offset-y="40">
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-hover v-model="hover">
																		<v-avatar v-on="on" v-bind="attrs" size="150" style="cursor: pointer" @click="openFileDialog()">
																			<v-img sizes="150" v-if="editedItem.image && editedItem.image.startsWith('data')" :src="editedItem.image"></v-img>
																			<v-img sizes="150" v-else-if="editedItem.image && !imgError" :src="profilePicture1(editedItem.image)" @error="imgError = !imgError"></v-img>
																			<v-icon v-else size="150">mdi-account-circle</v-icon>
																		</v-avatar>
																	</v-hover>
																</template>
																<span>It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB</span>
															</v-tooltip>
														</v-badge>

														<input type="file" ref="imageFile" accept="image/png, image/jpeg, image/jpg" style="display: none" @change="showImage" required />
													</v-row>
													<v-row>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.firstName" label="First Name" :rules="[rules.required]"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.lastName" label="Last Name" :rules="[rules.required]"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.email" label="Email" :rules="[rules.required, rules.email]"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.telephone" label="Telephone"></v-text-field>
														</v-col>
														<v-col cols="12" sm="12">
															<v-text-field v-if="isNewUser" v-model="editedItem.password" type="password" label="Password" :rules="[rules.required]" autocomplete="new-password"></v-text-field>
															<v-text-field v-else v-model="editedItem.password" type="password" label="Password" hint="Fill if you want to change the password" autocomplete="new-password"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.title" label="Title"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.company" label="Company"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.city" label="City"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.state" label="State"></v-text-field>
														</v-col>
														<v-col cols="12" sm="6">
															<v-select v-model="editedItem.ticketList" :items="ticketList" item-text="name" item-value="id" label="Ticket" multiple chips hint="Empty list means full access" persistent-hint></v-select>
														</v-col>
														<v-col cols="12" sm="6">
															<v-select v-model="editedItem.userType" :items="userTypeList" item-text="name" item-value="id" label="User Type" persistent-hint></v-select>
														</v-col>
														<v-col cols="12" sm="6">
															<v-select v-model="editedItem.businessnameId" :items="businessNameList.data" item-text="name" item-value="id" label="Business Name" persistent-hint></v-select>
														</v-col>
														<v-col cols="12" sm="6">
															<v-text-field v-model="editedItem.accountId" label="Account ID"></v-text-field>
														</v-col>
														<v-col cols="12" sm="12">
															<v-textarea v-model="editedItem.bio" label="Bio" outlined auto-grow dense></v-textarea>
														</v-col>
														<v-col cols="12" sm="12">
															<v-btn color="default" @click="dialogCategoryModule=true">Add Module Categories</v-btn>
															<br/>
															<div style="margin-top:10px">Selected Modules :</div>
															<div v-if="modules.length > 0">
																<ul>
																	<li v-for="(module, index) in modulesName" :key="index">
																		{{ module }}
																	</li>
																</ul>
															</div>
															<div v-else>
																N/A
															</div>
														</v-col>
														<v-col cols="12" sm="6">
															<v-switch v-model="editedItem.active" :label="editedItem.active ? 'Active' : 'Inactive'"></v-switch>
														</v-col>
                                                        <v-col cols="12" v-if="isNewUser">
															<v-switch
                                                                v-model="sendWelcomeEmail"
                                                                :label="sendWelcomeEmail
                                                                    ? 'Send Welcome Email'
                                                                    : 'Do not Send Welcome Email'"
                                                            />
														</v-col>
													</v-row>
												</v-container>
											</v-card-text>

											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="default" @click="close">Cancel</v-btn>
												<v-btn color="primary" :disabled="!validEditedItem" type="submit">Save</v-btn>
											</v-card-actions>
										</v-form>
									</v-card>
								</v-dialog>
								<v-dialog v-model="dialogDelete" max-width="400px">
									<v-card>
										<v-card-title class="headline warning justify-center pa-12" primary-title>
											<v-icon color="white" size="120">mdi-alert-circle-outline</v-icon>
										</v-card-title>

										<v-card-text class="pa-6" style="text-align: center">
											<span class="title">Warning</span>
											<br />
											<br />
											<p style="text-align: justify">Once you confirm, user account will be permanently deleted.</p>
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn color="default" @click="closeDelete">Cancel</v-btn>
											<v-btn color="error" @click="deleteItemConfirm">Confirm</v-btn>
											<v-spacer></v-spacer>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-col>
							<v-col cols="12" sm="10">
								<v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details @keyup="listExperienceUser()"></v-text-field>
							</v-col>
						</v-row>
					</template>
					<template v-slot:item.action="{ item }">
						<v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
						<v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
					</template>
				</v-data-table>

				<div class="d-flex flex-wrap justify-space-between pt-5 pb-5">
					<div></div>
					<div class="d-inline-flex">
						<span style="margin-top: 10px; font-size: 12px;"> Rows per page : </span>
						<v-select
							v-model="experienceUserList.size"
							:items="rowsPerPage"
							style="margin: -9px 0px 0px 10px; width: 60px; font-size: 12px;"
							@change="listExperienceUser()"
							hide-details=""
						></v-select>
						<span style="margin-top: 10px; margin-left: 20px; font-size: 12px;"> {{getPageLenght()}}</span>

						<v-pagination
							class="pl-6"
							v-model="experienceUserList.page"
							:length="experienceUserList.length"
							:total-visible="0"
							@input="listExperienceUser()"
							elevation="0"
						></v-pagination>
					</div>
				</div>
			</v-card>
		</div>

		<v-dialog v-model="dialog" persistent no-click-animation fullscreen transition="dialog-bottom-transition">
			<v-card tile>
				<v-card-title class="headline">
					Upload
					<v-spacer></v-spacer>
					<v-btn icon @click="closeDialog()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form ref="form" v-model="valid" @submit.prevent="uploadUser()">
						<v-row class="d-flex justify-center align-center">
							<v-col cols="12" sm="6">
								<v-file-input v-model="attachment" accept=".csv" placeholder="Upload your CSV file" prepend-icon="mdi-file-document" :show-size="1000">
									<template v-slot:selection="{ text }" :default="entity.background">
										<v-chip color="primary" dark label small>{{ text }}</v-chip>
									</template>
								</v-file-input>

								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Import</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEmailConfirmation" max-width="400px">
			<v-card>
				<v-card-title class="headline info justify-center pa-12" primary-title>
					<v-icon color="white" size="120">mdi-email-alert-outline</v-icon>
				</v-card-title>

				<v-card-text class="pa-6" style="text-align: center">
					<p style="text-align: justify">Do you want to continue sending the email?</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="default" @click="(emailList = []), (dialogEmailConfirmation = false)">Cancel</v-btn>
					<v-btn color="primary" @click="sendNotification(emailList)">Confirm</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogActive" max-width="500">
			<v-card>
				<v-card-title>Activate all users?</v-card-title>

				<v-card-text class="px-5">Do you want to activate all users?</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogActive = false">Cancel</v-btn>
					<v-btn color="primary" @click="activateAllUsers()">Activate</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogInactive" max-width="500">
			<v-card>
				<v-card-title>Deactivate all users?</v-card-title>

				<v-card-text class="px-5">Do you want to deactivate all users?</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogInactive = false">Cancel</v-btn>
					<v-btn color="primary" @click="deactivateAllUsers()">Deactivate</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSendEmailExhibitor" max-width="500px">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text>Send email and activate exhibitors ?</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogSendEmailExhibitor = false">Cancel</v-btn>
					<v-btn color="primary" text @click="sendEmail('Exhibitor')">Yes, sure</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSendEmailNonExhibitor" max-width="500px">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text>Send email to non-exhibitors ?</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogSendEmailNonExhibitor = false">Cancel</v-btn>
					<v-btn color="primary" text @click="sendEmail('Non-Exhibitor')">Yes, sure</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCategoryModule" max-width="500px">
			<v-card>
				<v-card-title>Select Category Modules</v-card-title>
				<v-container>
					<v-row class="pl-4">
						<v-col cols="12" sm="12">
							<input type='checkbox' @click='checkAll()' v-model='isCheckAll'> Check All
							<ul style="list-style-type:none;">
								<li v-for="(module, index) in moduleList" :key="index">
									<input type='checkbox' v-bind:value='module.categoryId' v-model='modules' @change='updateCheckall()'> {{ module.categoryName }}
								</li>
							</ul>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="dialogCategoryModule = false">Ok</v-btn>
							</v-card-actions>
						</v-col>
					</v-row>
				</v-container>


			</v-card>
		</v-dialog>
	</div>
</template>

<script>

import axios from "axios";

export default {
	data() {
		return {
			dialog: false,
			dialogEditedItem: false,
			dialogDelete: false,
			dialogEmailConfirmation: false,
			dialogActive: false,
			dialogInactive: false,
			dialogSendEmailExhibitor: false,
			dialogSendEmailNonExhibitor: false,
			dialogCategoryModule: false,
			valid: true,
			validEditedItem: true,
			isNewUser: true,
			entity: {},
			experienceUserList: { data: [], page: 1, size: 50, length: 0, total: 0 },
			emailList: [],
			selectAllUser: false,
			attachment: null,
			search: "",
			headers: [
				{ text: "Email", value: "email" },
				{ text: "First Name", value: "firstName" },
				{ text: "Last Name", value: "lastName" },
				{ text: "Title", value: "title" },
				{ text: "Company Name", value: "company" },
				{ text: "Photo", value: "image" },
				{ text: "Status", value: "active" },
				{ text: "Ticket List", value: "ticketNameList" },
				{ text: "User Type", value: "userType" },
				{ text: "Account ID", value: "accountId" },
				{ text: "Business Name", value: "businessname" },
				{ text: "Password Set", value: "passwordSet" },
				{ text: "Emailed", value: "emailed" },
				{ text: "Action", value: "action", sortable: false }
			],
			editedItem: { transitMap: {}, active: false },
			defaultItem: { transitMap: {}, active: false },
			imageFile: null,
			hover: false,
			imgError: false,
			rules: {
				required: (v) => !!v || "Required.",
				email: (v) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(v) || "Invalid e-mail.";
				}
			},
			ticketList: [],
			userTypeList: ["Tenant Admin", "Front-End Admin", "Front-End User"],
			baseLocation: axios.defaults.baseURL,
			rowsPerPage: [50, 100, 'All'],
			selectedModules: [],

			moduleList: [],
			isCheckAll: false,
			modules: [],
			modulesName: [],

			businessNameList: { data: [], page: 1, size: 1000, length: 0, total: 0 },

            sendWelcomeEmail: false,
		};
	},
	computed: {
		experienceId() {
			return this.$route.params.experienceId;
		},
		profilePicture: function () {
			return this.imageFile ? this.editedItem.image : this.baseLocation + "/asset/file/user/" + this.editedItem.image;
		},
		checkedModules() {
			var vm = this;
			vm.selectedModules = this.moduleList.filter(item => item.checked).map(categoryId => categoryId.categoryId);
			console.log(vm.selectedModules);
			return vm.selectedModules;
		}
	},
	mounted() {
		this.listExperienceUser();
		this.listTicket();
		this.getAllModules();
		this.getBusinessnameList();
	},
	methods: {
		getBusinessnameList() {
			axios
				.post("/system/businessname/list", {
					experienceId: this.experienceId,
					page: 1,
					size: this.businessNameList.total
				})
				.then((response) => {
					this.businessNameList = response.data;
					this.businessNameList.data.unshift({id: -1, name: '--Empty--'});
				})
				.catch(() => {});

		},
		uncheckAll() {
			this.isCheckAll = false;
			this.modules = [];
			this.modulesName = [];
		},
		checkAll(){
			this.isCheckAll = !this.isCheckAll;
			this.modules = [];
			this.modulesName = [];
			if(this.isCheckAll){ // Check all
				for (var key in this.moduleList) {
					this.modules.push(this.moduleList[key].categoryId);
					this.modulesName.push(this.moduleList[key].categoryName);
				}
			}
		},
		updateCheckall(){

			if(this.modules.length == this.moduleList.length){
				this.isCheckAll = true;
			} else{
				this.isCheckAll = false;
			}

			this.modulesName = [];
			let mods = this.moduleList.filter(mod => this.modules.includes(mod.categoryId) );
			mods.forEach(e => this.modulesName.push(e.categoryName));

		},
		getAllModules() {
			axios
				.post("/system/vTraining/category/list", {})
				.then((response) => {
					this.moduleList = response.data;
					console.log(this.moduleList);
				})
				.catch(() => {});
		},
		openDialog() {
			this.dialog = true;
			this.$refs.form.reset();
		},
		closeDialog() {
			this.dialog = false;
		},
		listExperienceUser() {
			if (this.experienceUserList.size === 'All') {
				this.experienceUserList.page = 1;
				this.experienceUserList.size = this.experienceUserList.total;
			}

			axios
				.post("/system/user/experience/paging", {
					experienceId: this.experienceId,
					keyword: this.search,
					page: this.experienceUserList.page,
					size: this.experienceUserList.size
				})
				.then((response) => {
					this.experienceUserList = response.data;
				})
				.catch(() => {});
		},
		uploadUser() {
			let formData = new FormData();
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios
				.post("/system/user/upload?experienceId=" + this.experienceId, formData)
				.then(() => {
					this.listExperienceUser();
					this.dialog = false;
					this.$refs.form.resetValidation();
				})
				.catch(() => {
					this.listExperienceUser();
					this.dialog = false;
					this.$refs.form.resetValidation();
				});
		},
		download(url) {
			window.open(this.baseLocation + url + "?experienceId=" + this.experienceId, "_blanks");
		},
		sendNotification(emailList) {
			this.dialogEmailConfirmation = false;
			let formData = new FormData();
			formData.append("entityList", JSON.stringify(emailList));
			axios
				.post("/system/user/send/notification", formData)
				.then(() => {
					this.listExperienceUser();
					this.emailList = [];
				})
				.catch(() => {});
		},
		sendEmail(type) {
			if (type == "Exhibitor") {
				this.dialogSendEmailExhibitor = false;
			} else {
				this.dialogSendEmailNonExhibitor = false;
			}

			axios
				.post("/system/user/send/email", {
					experienceId: this.experienceId,
					type: type
				})
				.then(() => {
					this.listExperienceUser();
					this.emailList = [];
				})
				.catch(() => {});
		},
		activateAllUsers() {
			this.dialogActive = false;
			axios
				.get("/system/user/all/active?experienceId=" + this.experienceId)
				.then(() => {
					this.listExperienceUser();
				})
				.catch(() => {});
		},
		deactivateAllUsers() {
			this.dialogInactive = false;
			axios
				.get("/system/user/all/inactive?experienceId=" + this.experienceId)
				.then(() => {
					this.listExperienceUser();
				})
				.catch(() => {});
		},
		toHexString(experienceId, text) {
			let result = "";
			for (let i = 0; i < text.length; i++) {
				result += text.charCodeAt(i).toString(16);
			}
			result = experienceId + "-" + result;
			if (result.length > 100) {
				result = result.substring(0, 100) + "*"; // means overflow
			}
			return result;
		},
		addItem() {
			this.isNewUser = true;
			this.imageFile = false;
			this.$refs.formEditedItem.resetValidation();
		},
		editItem(item) {
			this.isNewUser = false;
			this.imageFile = false;
			if (item.modules != null) {
				this.modules = JSON.parse(item.modules);
				this.updateCheckall();
			}
			this.editedItem = Object.assign({}, item);
			axios
				.get("/system/user/find?id=" + item.id)
				.then((response) => {
					this.editedItem.ticketList = response.data.ticketList;
					this.dialogEditedItem = true;
					this.editedItem.businessnameId = response.data.businessnameId == null ? -1 :  response.data.businessnameId;
				})
				.catch(() => {});
		},
		deleteItem(item) {
			this.editedItem = Object.assign({}, item);
			this.dialogDelete = true;
		},
		deleteItemConfirm() {
			axios
				.post("/system/user/delete", { id: this.editedItem.id })
				.then(() => {
					this.listExperienceUser();
					this.closeDelete();
				})
				.catch(() => {});
		},
		close() {
			this.selectedModules = [];
			this.uncheckAll();

			this.$refs.formEditedItem.resetValidation();
			this.dialogEditedItem = false;
			this.modules = [];
			this.modulesName = [];

            this.sendWelcomeEmail = false;

			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
			});
		},
		closeDelete() {
			this.dialogDelete = false;
			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
			});
		},
		save() {
			let formData = new FormData();
			this.editedItem.experienceId = this.experienceId;
			this.editedItem.modules = JSON.stringify(this.modules);
			this.editedItem.businessnameId = this.editedItem.businessnameId == -1 ? null : this.editedItem.businessnameId;

			formData.append("entity", JSON.stringify(this.editedItem));
			if (this.imageFile) {
				formData.append("attachment", this.imageFile);
			}
			var url = "/system/tenant/user/add";
			if (!this.isNewUser) {
				url = "/system/tenant/user/edit";
			}
			axios
				.post(url, formData)
				.then(() => {
					this.modules = [];
					this.modulesName = [];

                    if (this.sendWelcomeEmail) {
                        this.emailList.push(this.editedItem);
                        this.sendNotification(this.emailList);
                    }

					this.listExperienceUser();
					this.close();
				})
				.catch(() => {});
		},
		openFileDialog() {
			this.$refs.imageFile.click();
		},
		showImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.editedItem.image = fr.result;
					this.imageFile = files[0]; // this is an image file that can be sent to server...
					this.imgError = false;
				});
			} else {
				this.attachment = null;
			}
		},
		listTicket() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then((response) => {
					this.ticketList = response.data;
				})
				.catch(() => {});
		},
		profilePicture1(image) {
			return this.baseLocation + "/asset/file/user/" + image + "?avatar=default&time=" + new Date();
		},
		formatDateTime(obj) {
			let result = "";
			if (obj.date.year) {
				result = obj.date.year + "-" + this.lpad(obj.date.month) + "-" + this.lpad(obj.date.day) + " " + this.lpad(obj.time.hour) + ":" + this.lpad(obj.time.minute) + ":" + this.lpad(obj.time.second);
			}
			return result;
		},
		lpad(obj) {
			if (obj < 10) {
				obj = '0' + obj;
			}
			return obj;
		},
		getPageLenght(){
			let start = ((this.experienceUserList.page -1) * this.experienceUserList.size) + 1;
			let end = start + this.experienceUserList.size - 1;

			if (this.experienceUserList.total < end) {
				end = this.experienceUserList.total;
			}
			return start + "-" + end + " of " + this.experienceUserList.total;
		}
	}
};
</script>